<template>
  <section>
    <div class="z-card border-0 integration-page">
      <article>
        <h4>{{ $t('integration.api.stat_voice') }}</h4>
        <ul class="list-unstyled integration-list-info">
          <li><b>URL:</b> https://my.zorra.com/api/v1/voice/stats/general</li>
          <li><b>Content-Type:</b> application/json</li>
          <li><b>Method:</b> POST</li>
          <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
        </ul>
        <p>{{ $t('integration.api.example') }}</p>
        <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"date_to"</span>: <span class="hljs-string">"2019-01-20T16:15:09+01:00"</span>,
      <span class="hljs-attr">"date_from"</span>: <span class="hljs-string">"2019-01-15T16:15:09+01:00"</span>,
      <span class="hljs-attr">"source"</span>: <span class="hljs-string">"AutoCaller"</span>
  }
</code>
        </pre>

        <p>
          {{ $t('integration.api.answer_example') }}
        </p>
        <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"success"</span>: <span class="hljs-literal">true</span>,
      <span class="hljs-attr">"total"</span>: {
          <span class="hljs-attr">"answered"</span>: <span class="hljs-number">0</span>,
          <span class="hljs-attr">"busy"</span>: <span class="hljs-number">0</span>,
          <span class="hljs-attr">"no_answer"</span>: <span class="hljs-number">0</span>,
          <span class="hljs-attr">"failed"</span>: <span class="hljs-number">0</span>,
          <span class="hljs-attr">"total"</span>: <span class="hljs-number">0</span>,
          <span class="hljs-attr">"duration"</span>: <span class="hljs-number">0</span>,
          <span class="hljs-attr">"cost"</span>: <span class="hljs-number">0</span>,
          <span class="hljs-attr">"asr"</span>: <span class="hljs-number">0</span>,
          <span class="hljs-attr">"acd"</span>: <span class="hljs-number">0</span>
      },
      <span class="hljs-attr">"data"</span>: [
          {
              <span class="hljs-attr">"day"</span>: <span class="hljs-string">"2019-01-15"</span>,
              <span class="hljs-attr">"answered"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"busy"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"no_answer"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"failed"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"asr"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"acd"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"duration"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"cost"</span>: <span class="hljs-number">0</span>
          },
          {
              <span class="hljs-attr">"day"</span>: <span class="hljs-string">"2019-01-16"</span>,
              <span class="hljs-attr">"answered"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"busy"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"no_answer"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"failed"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"asr"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"acd"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"duration"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"cost"</span>: <span class="hljs-number">0</span>
          },
          {
              <span class="hljs-attr">"day"</span>: <span class="hljs-string">"2019-01-17"</span>,
              <span class="hljs-attr">"answered"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"busy"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"no_answer"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"failed"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"asr"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"acd"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"duration"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"cost"</span>: <span class="hljs-number">0</span>
          },
          {
              <span class="hljs-attr">"day"</span>: <span class="hljs-string">"2019-01-18"</span>,
              <span class="hljs-attr">"answered"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"busy"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"no_answer"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"failed"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"asr"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"acd"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"duration"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"cost"</span>: <span class="hljs-number">0</span>
          },
          {
              <span class="hljs-attr">"day"</span>: <span class="hljs-string">"2019-01-19"</span>,
              <span class="hljs-attr">"answered"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"busy"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"no_answer"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"failed"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"asr"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"acd"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"duration"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"cost"</span>: <span class="hljs-number">0</span>
          },
          {
              <span class="hljs-attr">"day"</span>: <span class="hljs-string">"2019-01-20"</span>,
              <span class="hljs-attr">"answered"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"busy"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"no_answer"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"failed"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"asr"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"acd"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"duration"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"cost"</span>: <span class="hljs-number">0</span>
          }
      ]
  }
</code>
        </pre>
      </article>

      <article>
        <h4>{{ $t('integration.api.stat_mailing') }}</h4>
        <ul class="list-unstyled integration-list-info">
          <li><b>URL:</b> https://my.zorra.com/api/v1/voice/stats/mailing</li>
          <li><b>Content-Type:</b> application/json</li>
          <li><b>Method:</b> POST</li>
          <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
        </ul>
        <p>{{ $t('integration.api.example') }}</p>
        <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"date_from"</span>: <span class="hljs-string">"2018-01-01 00:00"</span>,
      <span class="hljs-attr">"date_to"</span>: <span class="hljs-string">"2019-06-01 23:59"</span>,
      <span class="hljs-attr">"group_by"</span>: <span class="hljs-string">"day"</span>
  }
</code>
        </pre>
        <p>{{ $t('integration.api.answer_example') }}</p>
        <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"success"</span>: <span class="hljs-literal">true</span>,
      <span class="hljs-attr">"data"</span>: [
          {
              <span class="hljs-attr">"group_by"</span>: <span class="hljs-string">"2018-11-15"</span>,
              <span class="hljs-attr">"total"</span>: <span class="hljs-number">2</span>,
              <span class="hljs-attr">"cost"</span>: <span class="hljs-string">"0.028000"</span>,
              <span class="hljs-attr">"pending"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"processing"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"failed"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"sent"</span>: <span class="hljs-string">"1"</span>,
              <span class="hljs-attr">"delivered"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"not_delivered"</span>: <span class="hljs-string">"1"</span>,
              <span class="hljs-attr">"opened"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"expired"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"rejected"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"caption"</span>: <span class="hljs-string">"2018-11-15"</span>
          },
          {
              <span class="hljs-attr">"group_by"</span>: <span class="hljs-string">"2018-11-18"</span>,
              <span class="hljs-attr">"total"</span>: <span class="hljs-number">1</span>,
              <span class="hljs-attr">"cost"</span>: <span class="hljs-string">"0.014000"</span>,
              <span class="hljs-attr">"pending"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"processing"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"failed"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"sent"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"delivered"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"not_delivered"</span>: <span class="hljs-string">"1"</span>,
              <span class="hljs-attr">"opened"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"expired"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"rejected"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"caption"</span>: <span class="hljs-string">"2018-11-18"</span>
          },
          {
              <span class="hljs-attr">"group_by"</span>: <span class="hljs-string">"2018-11-19"</span>,
              <span class="hljs-attr">"total"</span>: <span class="hljs-number">2</span>,
              <span class="hljs-attr">"cost"</span>: <span class="hljs-string">"0.028000"</span>,
              <span class="hljs-attr">"pending"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"processing"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"failed"</span>: <span class="hljs-string">"1"</span>,
              <span class="hljs-attr">"sent"</span>: <span class="hljs-string">"1"</span>,
              <span class="hljs-attr">"delivered"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"not_delivered"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"opened"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"expired"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"rejected"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"caption"</span>: <span class="hljs-string">"2018-11-19"</span>
          }
      ],
      <span class="hljs-attr">"keys"</span>: [
          <span class="hljs-string">"pending"</span>,
          <span class="hljs-string">"processing"</span>,
          <span class="hljs-string">"failed"</span>,
          <span class="hljs-string">"sent"</span>,
          <span class="hljs-string">"delivered"</span>,
          <span class="hljs-string">"not_delivered"</span>,
          <span class="hljs-string">"opened"</span>,
          <span class="hljs-string">"expired"</span>,
          <span class="hljs-string">"rejected"</span>
      ],
      <span class="hljs-attr">"total"</span>: {
          <span class="hljs-attr">"total"</span>: <span class="hljs-number">5</span>,
          <span class="hljs-attr">"cost"</span>: <span class="hljs-number">0.07</span>,
          <span class="hljs-attr">"pending"</span>: <span class="hljs-number">0</span>,
          <span class="hljs-attr">"processing"</span>: <span class="hljs-number">0</span>,
          <span class="hljs-attr">"failed"</span>: <span class="hljs-number">1</span>,
          <span class="hljs-attr">"sent"</span>: <span class="hljs-number">2</span>,
          <span class="hljs-attr">"delivered"</span>: <span class="hljs-number">0</span>,
          <span class="hljs-attr">"not_delivered"</span>: <span class="hljs-number">2</span>,
          <span class="hljs-attr">"opened"</span>: <span class="hljs-number">0</span>,
          <span class="hljs-attr">"expired"</span>: <span class="hljs-number">0</span>,
          <span class="hljs-attr">"rejected"</span>: <span class="hljs-number">0</span>
      }
  }
</code>
        </pre>
      </article>
      <article>
        <h4>{{ $t('integration.api.stat_sms') }}</h4>

        <ul class="list-unstyled integration-list-info">
          <li><b>URL:</b> https://my.zorra.com/api/v1/voice/stats/sms</li>
          <li><b>Content-Type:</b> application/json</li>
          <li><b>Method:</b> POST</li>
          <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
        </ul>
        <p>{{ $t('integration.api.example') }}</p>
        <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"start"</span>: <span class="hljs-string">"2018-01-01 00:00"</span>,
      <span class="hljs-attr">"end"</span>: <span class="hljs-string">"2019-06-01 23:59"</span>,
      <span class="hljs-attr">"currency_id"</span>: <span class="hljs-number">2</span>,
      <span class="hljs-attr">"group_by"</span>: <span class="hljs-string">"country"</span>
  }
</code>
        </pre>
        <p>{{ $t('integration.api.answer_example') }}</p>
        <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"success"</span>: <span class="hljs-literal">true</span>,
      <span class="hljs-attr">"data"</span>: [
          {
              <span class="hljs-attr">"group_by"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"total"</span>: <span class="hljs-string">"15"</span>,
              <span class="hljs-attr">"def_client_cost"</span>: <span class="hljs-string">"0.000000"</span>,
              <span class="hljs-attr">"def_vendor_cost"</span>: <span class="hljs-string">"0.000000"</span>,
              <span class="hljs-attr">"pending"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"processing"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"failed"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"sent"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"delivered"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"not_delivered"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"opened"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"expired"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"rejected"</span>: <span class="hljs-string">"15"</span>,
              <span class="hljs-attr">"caption"</span>: <span class="hljs-string">"Unknown"</span>,
              <span class="hljs-attr">"vendor_cost"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"client_cost"</span>: <span class="hljs-number">0</span>
          },
          {
              <span class="hljs-attr">"group_by"</span>: <span class="hljs-number">250</span>,
              <span class="hljs-attr">"total"</span>: <span class="hljs-string">"9969"</span>,
              <span class="hljs-attr">"def_client_cost"</span>: <span class="hljs-string">"4015.902000"</span>,
              <span class="hljs-attr">"def_vendor_cost"</span>: <span class="hljs-string">"128.256160"</span>,
              <span class="hljs-attr">"pending"</span>: <span class="hljs-string">"1987"</span>,
              <span class="hljs-attr">"processing"</span>: <span class="hljs-string">"3589"</span>,
              <span class="hljs-attr">"failed"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"sent"</span>: <span class="hljs-string">"4391"</span>,
              <span class="hljs-attr">"delivered"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"not_delivered"</span>: <span class="hljs-string">"2"</span>,
              <span class="hljs-attr">"opened"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"expired"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"rejected"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"caption"</span>: <span class="hljs-string">"Russian Federation"</span>,
              <span class="hljs-attr">"vendor_cost"</span>: <span class="hljs-number">147.351</span>,
              <span class="hljs-attr">"client_cost"</span>: <span class="hljs-number">4613.805</span>
          },
          {
              <span class="hljs-attr">"group_by"</span>: <span class="hljs-number">410</span>,
              <span class="hljs-attr">"total"</span>: <span class="hljs-string">"1"</span>,
              <span class="hljs-attr">"def_client_cost"</span>: <span class="hljs-string">"0.000000"</span>,
              <span class="hljs-attr">"def_vendor_cost"</span>: <span class="hljs-string">"0.000000"</span>,
              <span class="hljs-attr">"pending"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"processing"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"failed"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"sent"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"delivered"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"not_delivered"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"opened"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"expired"</span>: <span class="hljs-string">"0"</span>,
              <span class="hljs-attr">"rejected"</span>: <span class="hljs-string">"1"</span>,
              <span class="hljs-attr">"caption"</span>: <span class="hljs-string">"Pakistan"</span>,
              <span class="hljs-attr">"vendor_cost"</span>: <span class="hljs-number">0</span>,
              <span class="hljs-attr">"client_cost"</span>: <span class="hljs-number">0</span>
          }
      ],
      <span class="hljs-attr">"keys"</span>: [
          <span class="hljs-string">"caption"</span>,
          <span class="hljs-string">"total"</span>,
          <span class="hljs-string">"pending"</span>,
          <span class="hljs-string">"processing"</span>,
          <span class="hljs-string">"failed"</span>,
          <span class="hljs-string">"sent"</span>,
          <span class="hljs-string">"delivered"</span>,
          <span class="hljs-string">"not_delivered"</span>,
          <span class="hljs-string">"opened"</span>,
          <span class="hljs-string">"expired"</span>,
          <span class="hljs-string">"rejected"</span>,
          <span class="hljs-string">"client_cost"</span>,
          <span class="hljs-string">"vendor_cost"</span>
      ],
      <span class="hljs-attr">"total"</span>: {
          <span class="hljs-attr">"total"</span>: <span class="hljs-number">9985</span>,
          <span class="hljs-attr">"def_client_cost"</span>: <span class="hljs-number">4015.902</span>,
          <span class="hljs-attr">"def_vendor_cost"</span>: <span class="hljs-number">128.25616</span>,
          <span class="hljs-attr">"pending"</span>: <span class="hljs-number">1987</span>,
          <span class="hljs-attr">"processing"</span>: <span class="hljs-number">3589</span>,
          <span class="hljs-attr">"failed"</span>: <span class="hljs-number">0</span>,
          <span class="hljs-attr">"sent"</span>: <span class="hljs-number">4391</span>,
          <span class="hljs-attr">"delivered"</span>: <span class="hljs-number">0</span>,
          <span class="hljs-attr">"not_delivered"</span>: <span class="hljs-number">2</span>,
          <span class="hljs-attr">"opened"</span>: <span class="hljs-number">0</span>,
          <span class="hljs-attr">"expired"</span>: <span class="hljs-number">0</span>,
          <span class="hljs-attr">"rejected"</span>: <span class="hljs-number">16</span>,
          <span class="hljs-attr">"vendor_cost"</span>: <span class="hljs-number">147.351</span>,
          <span class="hljs-attr">"client_cost"</span>: <span class="hljs-number">4613.805</span>
      }
  }
</code>
        </pre>
      </article>
    </div>
  </section>
</template>

<script>
  export default {};
</script>
<style lang="scss">
  @import '~@/assets/styles/scss/highlight/monokai';
  @import '~@/assets/styles/scss/pages/integration';
</style>
